import { Button, CircularProgress, Fade, Grid, Typography } from '@mui/material'
import { Link, Navigate } from 'react-router-dom'
import { styled } from '@mui/system'
import { useSnackbar } from 'notistack'

import logo from '../resources/images/logo.png'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { useAppSelector } from '../app/hooks'
import { getError, isLoading } from '../features/account/AccountSlice'
import { InAppBrowser } from '@capacitor/inappbrowser'

const Logo = styled('img')({
  width: 200,
  marginBottom: 40
})

export default function Login(){

  const {
    signinRedirect,
    signinSilent,
    activeNavigator,
    isAuthenticated,
    isLoading: authLoading,
    error: userError,
    user,
  } = useAuth()
  const logged = useMemo(() => isAuthenticated && user, [isAuthenticated, user]);
  const internalLoading = useAppSelector(isLoading)
  const internalError = useAppSelector(getError);
  const { enqueueSnackbar } = useSnackbar();
  const [browserClosed, setBrowserClosed] = useState(false);
  const loading = useMemo(() => (authLoading || internalLoading) && !browserClosed, [authLoading, internalLoading, browserClosed]);
  const error = useMemo(() => userError || internalError, [userError, internalError]);

  const logUser = useCallback(() => {
    if (activeNavigator)
      signinSilent()
    else
      signinRedirect()
  }, [activeNavigator, signinSilent, signinRedirect])

  useEffect(
    () => {
      if(error){
        console.debug("error", error)
        enqueueSnackbar(
          error.message,
          {variant: "error", preventDuplicate: true}
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [error]
  )

  useEffect(
    () => {
      if(!isAuthenticated && !loading){
        InAppBrowser.addListener("browserClosed", () => {
          setBrowserClosed(true)
        })
        InAppBrowser.addListener("browserPageLoaded", () => {
          setBrowserClosed(false)
        })
        logUser();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [logged, loading]
  )

  if(logged)
    return <Navigate replace to="/" />

  return <Grid
    container justifyContent="center"
    sx={{
      width: 1, height: '100vh', background: '#f2f2f2'
    }}
  >
    <Fade in={true} exit={true} mountOnEnter unmountOnExit>
    <Grid
      size={{ xs: 8, sm: 6, md: 4, lg: 3 }}
      container
      direction="column"
      justifyContent="center"
      alignItems="stretch"
      spacing={2}
    >
      <Grid container justifyContent="center">
        <Logo src={logo} alt="logo" />
      </Grid>
      <Grid container justifyContent="center">
        {error && !loading && <Typography variant="body1" align="center" gutterBottom>
          Un errore si è verificato durante l'accesso.<br/>Ti preghiamo di riprovare.
        </Typography>}
        {loading && <CircularProgress />}
      </Grid>
      <Grid>
        <Button
          variant="contained"
          fullWidth
          disabled={loading}
          onClick={logUser}
        >
          Riprova
        </Button>
      </Grid>
      <Button
        variant="text" size="small" color="primary"
        sx={{
          position: 'fixed', bottom: theme => theme.spacing(1),
          left: 0, right: 0, margin: 'auto', width: 'fit-content',
        }}
        component={Link}
        to="/privacy"
      >
        Privacy Policy
      </Button>
    </Grid>
    </Fade>
  </Grid>
}